import { LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import { App, Spin, Upload } from "antd";
import React, { useRef, useState } from "react";
import jsQR from "jsqr";
import TriggerClient from "./trigger/trigger_client";
import { useResponsive } from "hook/useResponsive";
import { useSupporterSearch } from "hook/supporters/useSupporter";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const QRUpload = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  const { loading, handleSearchById } = useSupporterSearch();
  const canvasRef = useRef(null);
  const { mobile } = useResponsive();
  const minWidth = mobile ? 300 : 500;
  // -------------------------- STATE ---------------------------
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // trước khi uplaod
  const beforeUpload = (file) => {
    console.log({ type: file.type });
    const isJpgOrPng = [
      "image/png",
      "image/jpg",
      "image/jpeg",
      "image/webp",
    ]?.includes(file.type);
    if (!isJpgOrPng) {
      message.error("Ảnh không đúng định dạng");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Ảnh nhỏ hơn 2MB");
    }
    return isJpgOrPng && isLt2M;
  };

  // sau khi uplaod
  const handleUpload = async (action) => {
    const file = action.file;

    if (!file) return message.error("File bị lỗi");

    const reader = new FileReader();
    reader.onload = async (e) => {
      const base64 = e.target.result;

      const { data, width, height } = await base64ToImageData(base64);
      const qrCode = jsQR(data, width, height, {
        inversionAttempts: "dontInvert",
      });

      if (!qrCode)
        return setError(
          "QR code không tìm thấy vì chất lượng ảnh kém, hãy đổi ảnh khác!",
        );

      const code = qrCode?.data;
      setResult(code);
    };
    reader.readAsDataURL(file);
  };

  // xử lý ảnh.
  const base64ToImageData = async (base64) => {
    // Tạo image element
    const img = new Image();
    img.src = base64;

    // Đợi ảnh tải xong
    await new Promise((resolve) => (img.onload = resolve));

    // Tạo canvas
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;

    // Vẽ ảnh lên canvas
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);

    // Lấy ImageData
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

    // Trả về Uint8ClampedArray
    return { data: imageData.data, width: canvas.width, height: canvas.height }; // <-- Đây chính là Uint8ClampedArray
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <>
      <Upload
        showUploadList={false}
        beforeUpload={beforeUpload}
        customRequest={handleUpload}
        accept="image/*"
        multiple={false}
        maxCount={1}
      >
        <div
          style={{
            width: "100%",
            minWidth,
            maxWidth: 500,
            cursor: "pointer",
            borderRadius: 5,
            minHeight: 200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px dashed rgba(0,0,0,0.2)",
            gap: 6,
          }}
        >
          {loading ? (
            <Spin indicator={<LoadingOutlined spin />} />
          ) : (
            <UploadOutlined style={{ color: "#aeaeae" }} />
          )}
          <span style={{ color: "#aeaeae" }}>Tải ảnh QR từ máy tính</span>
        </div>
      </Upload>
      {error && (
        <p style={{ color: "red", marginTop: "20px", textAlign: "center" }}>
          Lỗi: {error}
        </p>
      )}
      <TriggerClient handleSearchById={handleSearchById} result={result} />
      <canvas ref={canvasRef} style={{ display: "none" }} />
    </>
  );
};
export default QRUpload;
